import React, { SVGProps } from 'react';

const SvgCustomSpain = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 512 512'
		xmlSpace='preserve'
		width='1em'
		height='1em'
		className='svg-icon'
		{...props}>
		<rect width='512' height='170.667' y='0' fill='#c60b1e' />
		<rect width='512' height='170.667' y='170.667' fill='#ffc400' />
		<rect width='512' height='170.667' y='341.333' fill='#c60b1e' />
	</svg>
);

export default SvgCustomSpain;
